import React, { useEffect, useState } from 'react';
import { addTraders } from '../../api/traders';
import MultProd from './MultProd'; // Assuming this component exists for selecting products
import { getborders } from '../../api/border';

function ServiceForm() {
  const [productList, setProductList] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState('');
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [currency, setCurrency] = useState("");
  const [border, setBorder] = useState("");
  const [status, setStatus] = useState("");
  const [borderDatas, setBorderDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // For displaying error messages

  // Handlers for input fields
  const handleInputChange = (setter) => (e) => setter(e.target.value);

  // Fetch borders list
  useEffect(() => {
    const fetchBorders = async () => {
      setLoading(true);
      try {
        getborders((result) =>{
          if (result.ok === 1) {
            setBorderDatas(result.result);
          }
        })
        
      } catch (error) {
        console.error("Error fetching borders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBorders();
  }, []);

  // Validate form fields
  const validateFields = () => {
    if (!name) return "Full Name is required.";
    if (!email) return "Email is required.";
    if (!mobile) return "Mobile Number is required.";
    if (!country) return "Country is required.";
    if (!currency) return "Currency is required.";
    if (!status) return "Status is required.";
    if (!border) return "Border must be assigned.";
    if (productList.length === 0) return "At least one product must be assigned.";
    return null;
  };

  
  const submitHandler = async (event) => {
    event.preventDefault();

    const error = validateFields();
    if (error) {
      setErrorMessage(error);
      return;
    }

    setLoading(true);
    setErrorMessage(""); 

    const productData = {
      products: JSON.stringify(productList),
      name,
      email,
      mobile,
      country,
      address,
      currency,
      border,
      status,
    };

    try {
      addTraders(productData, (result) =>{
        if (result.ok === 1) {
          alert("Trader Added Successfully!");
          setName('');
          setEmail('');
          setMobile('');
          setCountry('');
          setAddress('');
          setCurrency('');
          setBorder('');
          setStatus('');
          setProductList([]);
        } else {
          alert("Error adding trader. Check your internet connection.");
        }
      });
       
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center mt-4">
      <div className="card p-4">
        <div className="card-body">
          <form method="post" onSubmit={submitHandler}>
            <div className='row mt-3'>
              <div className='col-md-6'>
                <label>Full Name</label>
                <input onChange={handleInputChange(setName)} value={name} type='text' className='form-control' placeholder='Trader Full Name' />
              </div>
              <div className='col-md-6'>
                <label>Email Address</label>
                <input onChange={handleInputChange(setEmail)} value={email} type='email' className='form-control' placeholder='Email Address' />
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-md-6'>
                <label>Mobile Number</label>
                <input onChange={handleInputChange(setMobile)} value={mobile} type='text' className='form-control' placeholder='Mobile Number' />
              </div>
              <div className='col-md-6'>
                <label>Country</label>
                <input onChange={handleInputChange(setCountry)} value={country} type='text' className='form-control' placeholder='Country' />
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-md-6'>
                <label>Currency</label>
                <select onChange={handleInputChange(setCurrency)} value={currency} className='form-control'>
                  <option value="">--Currency--</option>
                  <option value="TSH">TSH</option>
                  <option value="KSH">KSH</option>
                  <option value="UGX">UGX</option>
                  <option value="DOLLAR">DOLLAR</option>
                </select>
              </div>
              <div className='col-md-6'>
                <label>Assign Border</label>
                <select onChange={handleInputChange(setBorder)} value={border} className='form-control'>
                  <option value="">--Border Name--</option>
                  {borderDatas.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-md-12'>
                <label>Address</label>
                <textarea onChange={handleInputChange(setAddress)} value={address} className='form-control' placeholder='Address'></textarea>
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-md-6'>
                <label>Status</label>
                <select onChange={handleInputChange(setStatus)} value={status} className='form-control'>
                  <option value="">--Status--</option>
                  <option value="Approved">Approved</option>
                  <option value="Disabled">Disabled</option>
                </select>
              </div>
              <div className='col-md-6'>
                <label>Assign Products</label>
                <MultProd
                  productList={productList}
                  setProductList={setProductList}
                />
              </div>
            </div>

            {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}

            <div className="form-group mb-3">
              <button type="submit" className="btn btn-primary mt-4" disabled={loading}>
                {loading ? "Adding..." : "Add Trader"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ServiceForm;
